import { render, staticRenderFns } from "./IbDialogHeader.vue?vue&type=template&id=68d4e4c6"
import script from "./IbDialogHeader.vue?vue&type=script&lang=js"
export * from "./IbDialogHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports